module.exports = __webpack_public_path__ + "img/profile-2.53c694f3.png";